export enum ProductCategory {
	PHONE = "Mobiltelefoner",
	WATCH = "Smartklokker",
	TABLET = "Nettbrett",
	GOOD_AS_NEW = "God Som Ny",
	SOUND = "Lyd",
	ROUTER = "Ruter",
	ACCESSORY = "Tilbehør",
}
